<template>
  <div>
    <h1>This is a AboutInfo page.</h1>
  </div>
</template>
